module.exports = {"id":"s1-q4","text":"Does your job require you to use email or instant messenger to maintain contact with colleagues or clients/customers?","multiselect":false,"options":[{"text":"Yes","id":"s1-q4-a1","capability":1,"access":1,"focusarea":[0,3,4,3,0]},{"id":"s1-q4-a2","text":"No","capability":-2,"access":-1}],"conditionalnext":{"capability":6,"next":"s6-q1","else":"s2-q1"}}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s1-q4.json
// module id = 892
// module chunks = 41